// components
import Column from '@drivesally/sally-ui/lib/components/Grid/Column/Column';
import Modal from '@drivesally/sally-ui/lib/components/Modal/Modal';
import Row from '@drivesally/sally-ui/lib/components/Grid/Row/Row';

// layout components
import AttributeInput from '../../../components/components/atoms/AttributeInput/AttributeInput';

// propTypes
import PropTypes from 'prop-types';

// react
import React from 'react';

// rental lib
import isOtherRepoReason from '../../lib/isOtherRepoReason.lib.rental';

const RepoRentalModal = ({
  onChange,
  onClose,
  onSave,
  repo_start_date,
  saving,
  visible,
  custom_repo_reason,
  repo_reason,
}) => (
  <Modal
    title="Begin Deactivation"
    visible={visible}
    onClose={onClose}
    buttonsRight={[
      {
        label: 'Begin Deactivation',
        onClick: onSave,
        loading: saving,
      },
    ]}
    size="small"
  >
    {(Content) => {
      return (
        <Content>
          <Row margin>
            <Column>
              <AttributeInput
                value={repo_reason}
                onChange={onChange}
                disabled={saving}
              >
                {repo_reason.label.default}
              </AttributeInput>
            </Column>
          </Row>
          {isOtherRepoReason(repo_reason) && (
            <Row margin>
              <Column>
                <AttributeInput
                  value={custom_repo_reason}
                  onChange={onChange}
                  disabled={saving}
                >
                  {custom_repo_reason.label.default}
                </AttributeInput>
              </Column>
            </Row>
          )}
          <Row>
            <Column>
              <AttributeInput
                value={repo_start_date}
                onChange={onChange}
                disabled={saving}
                disabledDates={[{after: new Date()}]}
              >
                {repo_start_date.label.default}
              </AttributeInput>
            </Column>
          </Row>
          <Row>
            <Column>
              <div style={{color: 'red', marginTop: '12px'}}>
                A reactivation fee will be added automatically.
              </div>
            </Column>
          </Row>
        </Content>
      );
    }}
  </Modal>
);

RepoRentalModal.propTypes = {
  custom_repo_reason: PropTypes.object,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  rental: PropTypes.object,
  repo_reason: PropTypes.object,
  repo_start_date: PropTypes.object,
  saving: PropTypes.bool,
  visible: PropTypes.bool,
};

export default RepoRentalModal;
